<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('sales_center.sales_entry')}}</h4>
            </template>
            <template v-slot:headerAction>
                <router-link to="sales-list" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{  $t('sales_center.sales') + ' ' + $t('globalTrans.list') }}</router-link>
            </template>
            <template v-slot:body>
                <b-overlay :show="qtyLoad">
                    <ValidationObserver ref="formAddProduct" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(addProduct)" @reset.prevent="reset">
                            <b-row>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Product Category" vid="category_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="category_id "
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('production_store.pro_category')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="detailsFormData.category_id"
                                            id="category_id"
                                            :options="categoryList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="sub_category_id "
                                        >
                                        <template v-slot:label>
                                        {{$t('production_store.pro_sub_category')}}
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="detailsFormData.sub_category_id"
                                        id="sub_category_id"
                                        :options="subCategoryList"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Product Name" vid="product_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="product_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('production_store.pro_name')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="detailsFormData.product_id"
                                            id="product_id"
                                            :options="productList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Product Unit" vid="unit_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="unit_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('production_store.pro_unit')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="detailsFormData.unit_id"
                                            id="unit_id"
                                            :options="productUnitList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Avaiable Quantity" vid="available_quantity|numeric">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="available_quantity"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{$t('production_store.available_quantity')}}
                                        </template>
                                        <b-form-input
                                        id="available_quantity"
                                        readonly
                                        v-model="detailsFormData.available_quantity"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Quantity" vid="delivery_quantity" :rules="{required: true, min_value: 1, max_value: detailsFormData.available_quantity}">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="delivery_quantity"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('retailerManagement.quantity') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                id="delivery_quantity"
                                                v-model="detailsFormData.delivery_quantity"
                                                @input="changeQty()"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <ValidationProvider name="Unit Price" vid="unit_price" :rules="{required: true, regex: /^\d*\.?\d*$/}">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="unit_price"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('retailerManagement.unit_price') }} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                id="unit_price"
                                                v-model="detailsFormData.unit_price"
                                                @input="changePrice()"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="12">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="total"
                                        >
                                        <template v-slot:label>
                                            {{ $t('retailerManagement.total_price') }} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            readonly
                                            id="total"
                                            v-model="detailsFormData.total"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="12" sm="12">
                                    <div class="text-right">
                                        <b-button type="submit" variant="primary">{{ $t('globalTrans.add') }}</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form>
                    </ValidationObserver>
                </b-overlay>
                <b-overlay :show="loadingList">
                    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                            <b-row class="mt-4">
                                <b-col>
                                    <table class="table table-bordered">
                                        <tr class="bg-light">
                                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                            <th>{{ $t('production_store.pro_name') }}</th>
                                            <th>{{ $t('production_store.pro_unit') }}</th>
                                            <th>{{ $t('production_store.available_quantity') }}</th>
                                            <th>{{ $t('retailerManagement.quantity') }}</th>
                                            <th>{{ $t('retailerManagement.unit_price') }}</th>
                                            <th>{{ $t('retailerManagement.total_price') }}</th>
                                            <th>{{ $t('globalTrans.action') }}</th>
                                        </tr>
                                        <tr v-for="(item, index) in dataArray.details" :key="index">
                                            <td>{{ $n(index + 1) }}</td>
                                            <td>{{ productNameById(item.product_id) }}</td>
                                            <td>{{ unitNameById(item.unit_id) }}</td>
                                            <td>{{ item.available_quantity }}</td>
                                            <td>
                                                <ValidationProvider name="Sales quantity" rules="required|numeric|min_value:1">
                                                    <b-form-group
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                        <b-form-input
                                                        v-model="item.delivery_quantity"
                                                        @input="changeItemQty(item)"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                        <div class="invalid-feedback d-block">
                                                            {{ item.message }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </td>
                                            <td>
                                                <ValidationProvider name="Unit Price" :rules="{required: true, regex: /^\d*\.?\d*$/}">
                                                    <b-form-group
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                        <b-form-input
                                                        :readonly="dataArray.type_id == 1 ? true : false"
                                                        v-model="item.unit_price"
                                                        @input="changeItemPrice(item)"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </td>
                                            <td>{{ item.total }}</td>
                                            <td>
                                                <button @click="deleteItem(index)" class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                                            </td>
                                        </tr>
                                        <b-td colspan="6">
                                            <p style="margin-left:85%">{{ $t('sales_center.grand_total') }}</p>
                                        </b-td>
                                        <b-td colspan="2">{{ getGrandTotal() }}</b-td>
                                    </table>
                                </b-col>
                                <b-col lg="12">
                                    <b-row class="text-right">
                                        <b-col lg="12" sm="12">
                                            <ValidationProvider name="Discount Type" vid="discount_type">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="discount_type "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.discount_type') }}
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.discount_type"
                                                    id="discount_type"
                                                    :options="discountTypeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-show="discountShow" name="Discount Amount" vid="discount_amount" :rules="{required: false, regex: /^\d*\.?\d*$/}">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="discount_amount "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.discount_amount') }}
                                                    </template>
                                                    <b-form-input
                                                    plain
                                                    @input="calculateDiscount()"
                                                    v-model="dataArray.discount_amount"
                                                    id="discount_amount"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-show="discountPShow" name="Discount Percentage" vid="discount_amount" :rules="{required: false, regex: /^\d*\.?\d*$/}">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="discount_amount "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.discount_p') }}
                                                    </template>
                                                    <b-form-input
                                                    plain
                                                    @input="calculateDiscount()"
                                                    v-model="dataArray.discount_amount"
                                                    id="discount_amount"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="After Discount" vid="after_discount">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="after_discount "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.after_discount') }}
                                                    </template>
                                                    <b-form-input
                                                    readonly
                                                    plain
                                                    v-model="dataArray.after_discount"
                                                    id="after_discount"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="VAT" vid="vat" :rules="{required: false, regex: /^\d*\.?\d*$/}">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="vat "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.vat_if') }}
                                                    </template>
                                                    <b-form-input
                                                    plain
                                                    @input="calculateVat()"
                                                    v-model="dataArray.vat"
                                                    id="vat"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="Total Paid Amount" vid="totalPrice" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="9"
                                                    label-for="totalPrice "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{ $t('sales_center.total_paid') }} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                    readonly
                                                    plain
                                                    v-model="dataArray.totalPrice"
                                                    id="totalPrice"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <div class="row">
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import flatpickr from 'flatpickr'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { salesEntryStoreApi, availableStockAndPriceApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
    components: {
        ValidationObserver,
        ValidationProvider
    },
  data () {
    return {
        saveBtnName: this.$t('globalTrans.save'),
        discountShow: false,
        discountPShow: false,
        detailsFormData: {
            category_id: 0,
            sub_category_id: 0,
            product_id: 0,
            unit_id: 0,
            delivery_quantity: '',
            unit_price: 0,
            total: 0,
            available_quantity: 0
        },
        dataArray: {
            sales_center_id: this.$store.state.Auth.authUser.office_id,
            details: [],
            discount_amount: '',
            vat: '',
            discount_type: 0,
            after_discount: '',
            after_vat: '',
            totalPrice: '',
            grandTotal: 0
        },
        message: '',
        qtyLoad: false,
        loadingList: false,
        subCategoryList: [],
        productList: [],
        productUnitList: [],
        discountType: [
            { value: 1, text_en: 'Percentage', text_bn: 'শতকরা হার' },
            { value: 2, text_en: 'Amount', text_bn: 'পরিমাণ' }
        ]
    }
  },
  computed: {
    discountTypeList: function () {
        return this.discountType.map(item => {
            return Object.assign({}, item, { text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    categoryList: function () {
        return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'detailsFormData.category_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.subCategoryList = this.getSubCatList(newVal)
            this.productList = this.getProductListByCat(newVal)
        }
    },
    'detailsFormData.sub_category_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.productList = this.getProductList(newVal)
        }
    },
    'detailsFormData.product_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.productUnitList = this.getUnitList(newVal)
            this.detailsFormData.unit_id = 0
            this.detailsFormData.available_quantity = 0
            this.detailsFormData.unit_price = 0
        }
    },
    'detailsFormData.unit_id': function (newVal, oldVal) {
        if (newVal === 0) {
            this.qtyLoad = false
        } else {
            if (newVal !== oldVal) {
                this.detailsFormData.available_quantity = 0
                this.detailsFormData.unit_price = 0
                this.getStockAndPrice()
            }
        }
    },
    'dataArray.discount_type': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (newVal === 1) {
                this.discountShow = false
                this.discountPShow = true
            } else if (newVal === 2) {
                this.discountShow = true
                this.discountPShow = false
            } else {
                this.discountShow = false
                this.discountPShow = false
            }
            this.dataArray.discount_amount = 0
            this.dataArray.vat = 0
            this.dataArray.after_discount = 0
            this.dataArray.after_vat = 0
        }
    }
  },
  created () {
  },
  mounted () {
    flatpickr('#delivery_date', {})
  },
  methods: {
    calculateDiscount () {
          if (this.dataArray.discount_type === 1) {
              const total = (parseFloat(this.dataArray.grandTotal) * parseFloat(this.dataArray.discount_amount)) / 100
              this.dataArray.after_discount = parseFloat(this.dataArray.grandTotal) - parseFloat(total)
              this.dataArray.totalPrice = this.dataArray.after_discount
          } else {
              this.dataArray.after_discount = parseFloat(this.dataArray.grandTotal) - parseFloat(this.dataArray.discount_amount)
              this.dataArray.totalPrice = this.dataArray.after_discount
          }
        this.dataArray.vat = 0
        this.dataArray.after_vat = 0
    },
    calculateVat () {
        if (this.dataArray.after_discount) {
            const total = (this.dataArray.after_discount * parseFloat(this.dataArray.vat)) / 100
            this.dataArray.after_vat = this.dataArray.totalPrice + total
            this.dataArray.totalPrice = this.dataArray.after_vat
        } else {
            const total = (parseFloat(this.dataArray.grandTotal) * parseFloat(this.dataArray.vat)) / 100
            this.dataArray.after_vat = this.dataArray.totalPrice + total
            this.dataArray.totalPrice = this.dataArray.after_vat
        }
    },
    getStockAndPrice () {
        const params = {
            sales_center_id: this.$store.state.Auth.authUser.office_id,
            product_id: this.detailsFormData.product_id,
            unit_id: this.detailsFormData.unit_id
        }
        this.qtyLoad = true
        RestApi.getData(productionServiceBaseUrl, availableStockAndPriceApi, params).then(response => {
            if (response.success) {
                if (response.price && response.stock) {
                    this.detailsFormData.unit_price = response.price.recommended_price
                    this.detailsFormData.available_quantity = response.stock.stock_quantity
                    this.qtyLoad = false
                } else {
                    this.detailsFormData.unit_price = 0
                    this.detailsFormData.available_quantity = 0
                    this.qtyLoad = false
                }
            }
        })
    },
    changeQty () {
        if (this.detailsFormData.unit_price) {
            const result = this.detailsFormData.delivery_quantity * parseFloat(this.detailsFormData.unit_price)
            this.detailsFormData.total = parseFloat(result.toFixed(2))
        }
    },
    changePrice () {
        if (this.detailsFormData.delivery_quantity) {
            const result = this.detailsFormData.delivery_quantity * parseFloat(this.detailsFormData.unit_price)
            this.detailsFormData.total = parseFloat(result.toFixed(2))
        }
    },
    changeItemQty (item) {
        if (item.unit_price) {
            const result = item.delivery_quantity * parseFloat(item.unit_price)
            item.total = parseFloat(result.toFixed(2))
        }
        if (item.available_quantity < parseFloat(item.delivery_quantity)) {
            item.message = 'Sales quantity must not be greater than available quantity'
        } else {
            item.message = ''
        }
    },
    changeItemPrice (item) {
        if (item.delivery_quantity) {
            const result = item.delivery_quantity * parseFloat(item.unit_price)
            item.total = parseFloat(result.toFixed(2))
        }
    },
    getGrandTotal () {
        const total = this.dataArray.details.reduce((total, item) => total + item.total, 0)
        this.dataArray.grandTotal = total
        this.dataArray.totalPrice = this.dataArray.after_discount ? this.dataArray.after_discount : total
        this.dataArray.totalPrice = this.dataArray.after_vat ? this.dataArray.after_vat : this.dataArray.totalPrice
        return total
    },
    deleteItem (index) {
        this.dataArray.details.splice(index, 1)
    },
    cancel () {
        this.$router.push({ path: '/production-service/sales-center/sales-list' })
        this.detailsFormData = {
            category_id: 0,
            sub_category_id: 0,
            product_id: 0,
            unit_id: 0,
            delivery_quantity: '',
            unit_price: 0,
            total: 0
        }
        this.$router.push({ path: '/production-service/sales-center/sales-list' })
        this.dataArray.details = []
        this.dataArray.discount_amount = ''
        this.dataArray.vat = ''
        this.dataArray.discount_type = 0
        this.dataArray.after_discount = ''
        this.dataArray.after_vat = ''
        this.dataArray.totalPrice = ''
    },
    addProduct () {
        this.qtyLoad = false
        if (this.detailsFormData.category_id !== 0 && this.detailsFormData.product_id !== 0 && this.detailsFormData.unit_id !== 0 && this.detailsFormData.available_quantity !== 0 && this.detailsFormData.delivery_quantity !== '' && this.detailsFormData.unit_price !== 0) {
            const categoryId = this.detailsFormData.category_id
            const productId = this.detailsFormData.product_id
            const unitId = this.detailsFormData.unit_id
            const product = this.dataArray.details.find(item => item.product_id === productId && item.unit_id === unitId && item.category_id === categoryId)
            if (typeof product === 'undefined') {
                this.dataArray.details.push(JSON.parse(JSON.stringify(this.detailsFormData)))
                this.detailsFormData.product_id = 0
                this.detailsFormData.unit_id = 0
                this.detailsFormData.delivery_quantity = ''
                this.detailsFormData.unit_price = 0
                this.detailsFormData.total = 0
            } else {
                product.delivery_quantity = parseInt(product.delivery_quantity) + parseInt(this.detailsFormData.delivery_quantity)
                product.unit_price = this.detailsFormData.unit_price
                product.total = parseFloat(product.unit_price) * parseFloat(product.delivery_quantity)
                this.detailsFormData.product_id = 0
                this.detailsFormData.unit_id = 0
                this.detailsFormData.delivery_quantity = ''
                this.detailsFormData.unit_price = 0
                this.detailsFormData.total = 0
            }
        }
    },
    async saveData () {
        let result = null
        this.loadingList = true
        result = await RestApi.postData(productionServiceBaseUrl, salesEntryStoreApi, this.dataArray)
        this.loadingList = false

        if (result.success) {
            this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
            this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
            })
            this.$router.push({ path: '/production-service/sales-center/sales-list' })
        } else {
            this.$toast.error({
                title: this.$t('globalTrans.error'),
                message: result.message,
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
        }
    },
    getSubCatList (catId) {
        return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductListByCat (catId) {
        return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductList (subCatId) {
        return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 2)
    },
    getUnitList (proId) {
        return this.productCommonObj.productUnitList.filter(item => item.product_id === proId && item.status === 1)
    },
    productCategoryById (id) {
        const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
        if (this.$i18n.locale === 'bn') {
            return category.text_bn
        } else {
            return category.text_en
        }
    },
    productSubCategoryById (id) {
        const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
        if (this.$i18n.locale === 'bn') {
            return subCategory.text_bn
        } else {
            return subCategory.text_en
        }
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
        const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
        if (this.$i18n.locale === 'bn') {
            return unit.text_bn
        } else {
            return unit.text_en
        }
    }
  }
}
</script>
